<template>
  <b-card
    no-body
    class="card-transaction"
  >
    <b-card-header>
      <div>
        <b-card-title>Latest Users</b-card-title>
        <b-card-text class="font-small-2">
          {{ selectedFilter }}
        </b-card-text>
      </div>

      <b-dropdown
        variant="link"
        no-caret
        class="chart-dropdown"
        toggle-class="p-0"
      >
        <template #button-content>
          <feather-icon
            icon="MoreVerticalIcon"
            size="18"
            class="text-body cursor-pointer"
          />
        </template>
        <b-dropdown-item
          v-for="option in filterOptions"
          :key="option"
          @click="selectedFilter = option"
        >
          {{ option }}
        </b-dropdown-item>
      </b-dropdown>
    </b-card-header>

    <!-- body -->
    <b-card-body>
      <div
        v-if="response.isLoading"
        class="d-flex align-items-center justify-content-center h-100"
      >
        <feather-icon
          icon="LoaderIcon"
          class="spinner"
          size="60"
        />
      </div>
      <template v-else>
        <div
          v-for="user in response.data"
          :key="user.id"
          class="transaction-item"
        >
          <b-media
            no-body
            class="flex-grow-1 mr-1"
          >
            <b-media-aside>
              <div
                class="b-avatar rounded-circle"
                :style="{
                  fontSize: '14px',
                  width: '42px',
                  height: '42px',
                  backgroundColor: randomColor({
                    luminosity: 'light',
                    seed: `${user.firstname[0] + user.lastname[0]}`,
                    format: 'rgba',
                    alpha: 0.3,
                  }),
                  color: randomColor({
                    luminosity: 'bright',
                    seed: `${user.firstname[0] + user.lastname[0]}`,
                  }),
                }"
              >
                <b-img
                  v-if="user.profilePhoto"
                  :src="user.profilePhoto"
                  alt="profile_image"
                />
                <span v-else>
                  {{ user.firstname[0] + user.lastname[0] }}
                </span>
              </div>
            </b-media-aside>
            <b-media-body>
              <div class="d-flex">
                <h6
                  class="transaction-title text-truncate flex-grow-1"
                  style="width: 20px"
                >
                  {{ user.firstname }} {{ user.lastname }}
                </h6>
              </div>
              <div class="d-flex">
                <small
                  class="text-truncate flex-grow-1"
                  style="width: 20px"
                >
                  @{{ user.username }}
                </small>
              </div>
            </b-media-body>
          </b-media>
          <small
            class="round font-weight-bold d-inline-block"
            :style="{
              padding: '2px 6px',
              fontSize: '12px',
              backgroundColor: randomColor({
                luminosity: 'light',
                seed: `${user.userCategory}`,
                format: 'rgba',
                alpha: 0.3,
              }),
              color: randomColor({
                luminosity: 'bright',
                seed: `${user.userCategory}`,
              }),
            }"
          >
            {{ user.userCategory }}
          </small>
        </div>
      </template>
    </b-card-body>
    <!--/ body -->
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BMedia, BMediaAside, BMediaBody, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import randomColor from 'randomcolor'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useApi } from '@core/comp-functions/useApi'

const [res, apiRequest] = useApi('users')

const filterOptions = ['Today', 'This Week', 'This Month', 'This Year']

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BMediaAside,
    BMediaBody,
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      selectedFilter: filterOptions[3],
      response: res,
    }
  },
  computed: {
    filterOptions: () => filterOptions,
  },
  watch: {
    'response.isFailure': function (isFailure) {
      if (isFailure) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            text: this.response.error || 'Failed to fetch resource',
            icon: 'TrashIcon',
            variant: 'danger',
          },
        })
      }
    },

    selectedFilter: {
      handler(value) {
        let startDate
        if (value === 'This Year') {
          startDate = `01-01-${new Date().getFullYear()}`
        } else if (value === 'This Week') {
          startDate = this.getMonday()
        } else if (value === 'This Month') {
          startDate = this.getFirstDayOfTheMonth()
        } else if (value === 'Today') {
          const date = new Date()
          date.setDate(date.getDate() - 1)
          startDate = new Date(date).toISOString().substring(0, 10)
        }
        apiRequest({
          // filter: value.replace(/^This\s+/, '').toUpperCase(),
          startDate,
          // endDate: new Date().toISOString().substring(0, 10),
          offset: 0,
          limit: 5,
        })
      },
      immediate: true,
    },
  },
  methods: {
    randomColor,
    getMonday() {
      const d = new Date()
      const day = d.getDay()
      const diff = d.getDate() - day + (day === 0 ? -6 : 1) // adjust when day is sunday
      return new Date(d.setDate(diff)).toISOString().substring(0, 10)
    },
    getFirstDayOfTheMonth() {
      const date = new Date()
      const firstDay = new Date(`${date.getFullYear()},${date.getMonth() + 1},1`).toISOString().substring(0, 10)
      return firstDay
    },
  },
}
</script>
